import {useEffect} from 'react'

export const usePopstateListener = (close?: () => void): void => {
  useEffect(() => {
    if (!close) {
      return undefined
    }

    const listener = (): void => {
      close()
    }
    window.addEventListener('popstate', listener)

    return () => {
      window.removeEventListener('popstate', listener)
    }
  }, [])
}
